export default __webpack_public_path__ + "static/media/menu.21142438.svg";